import { Box } from '@mui/material';
import { debounce } from 'lodash';
import { FC } from 'react';
import { useEventBus } from '../../../../hooks/use-event-bus';
import { VerificationPriority } from '../../../../services/insurance/types/verification-priority';
import { EventIvShowNoInsuranceDialog } from '../../../../types/event-bus';
import { StatusText, StatusWrapper, UnknownVerificationStatus } from '../../shared/styles';

export interface UnknownPatientIvStatusButtonProps {
  locationId: number;
  patientId: number | undefined;
  verificationPriority?: VerificationPriority;
}

export const UnknownPatientIvStatusButton: FC<UnknownPatientIvStatusButtonProps> = (props) => {
  const { locationId, patientId, verificationPriority } = props;
  const { publish } = useEventBus();

  const handlePatientFlowClick = debounce(() => {
    if (!patientId) return;

    publish({
      messageType: 'ivShowNoInsuranceDialog',
      data: {
        patientId,
        locationId,
        priority: verificationPriority
      }
    } as EventIvShowNoInsuranceDialog);
  }, 1000);

  return (
    <>
      <StatusWrapper>
        <UnknownVerificationStatus />
        <Box sx={{ display: 'flex', flexDirection: 'column', marginLeft: '8px' }}>
          <StatusText onClick={handlePatientFlowClick}>Unknown</StatusText>
        </Box>
      </StatusWrapper>
    </>
  );
};
